import { useSelector } from 'react-redux';

import type { RootState } from '@/redux/RootReducer';

export const useGetSelectedCompanyId = () => {
  return useSelector((state: RootState) => {
    const selectedCompany = state.auth.selectedCompany;
    const selectedCompanyId =
      selectedCompany?.companyId ?? selectedCompany?.CompanyID ?? state.auth.user?.data?.selectedCompany;

    return Number(selectedCompanyId) || undefined;
  });
};
